module.exports = __webpack_public_path__ + "img/Checked Checkbox.18dbff5b.svg";